module.exports = __webpack_public_path__ + "assets/img/new_banner.975fd6d5.png";